import React, { Component } from 'react';
import { FaExclamation } from 'react-icons/fa';
import styled from 'styled-components';

export const InputBox = styled.div`
  position: relative;

  input {
    padding: 15px;
    width: 100%;
    line-height: 1.3;

    &:disabled {
      background-color: #f5f5f5;
    }

    @media (min-width: 992px) {
      padding: 23px 25px;
    }
  }
  .animation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: none;
    border: 0;
    vertical-align: middle;
    color: lightgrey;
    font-size: inherit;
    font-weight: 700;
    pointer-events: none;
    transition: color 0.25s;
    z-index: 5;

    @media (min-width: 992px) {
      &::before,
      &::after {
        box-sizing: inherit;
        content: '';
        position: absolute;
        border: 1.5px solid transparent;
        width: 0;
        height: 0;
      }

      &::before {
        top: 0;
        left: 0;
      }

      &::after {
        bottom: 0;
        right: 0;
      }
    }
  }

  input:focus + span {
    color: #177dff;
  }

  input:focus + span:before,
  input:focus + span:after {
    width: 100%;
    height: 100%;
  }

  input:focus + span:before {
    border-top-color: #177dff;
    border-right-color: #177dff;
    transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
  }

  input:focus + span:after {
    border-bottom-color: #177dff;
    border-left-color: #177dff;
    transition: border-color 0s ease-out 0.5s, width 0.25s ease-out 0.5s,
      height 0.25s ease-out 0.75s;
  }
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  color: #ff3b30;
  z-index: 6;

  @media (min-width: 992px) {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translate(0, -50%);

    &:hover {
      .errorText {
        visibility: visible;
        opacity: 1;
      }
    }
  }

  svg {
    position: relative;
    display: none;
    fill: #ff3b30;
    z-index: 7;

    @media (min-width: 992px) {
      display: inline-block;
    }
  }

  .errorText {
    text-align: left;
    transition: all 0.2s ease;

    @media (min-width: 992px) {
      position: absolute;
      top: 50%;
      right: -5px;
      width: 250px;
      text-align: right;
      visibility: hidden;
      opacity: 0;
      transform: translateY(-50%);
    }
  }

  .innerErrorText {
    display: inline-block;
    margin-bottom: 5px;
    padding: 4px 15px;
    background-color: #fff;
    color: #c80000;
    font-size: 13px;
    line-height: 1.4;
    text-align: left;
    pointer-events: none;

    @media (min-width: 992px) {
      max-width: 100%;
      margin-bottom: 0;
      border: 1px solid #c80000;
      border-radius: 2px;
      padding: 4px 25px 4px 10px;
    }
  }
`;

class Input extends Component {
  render() {
    const { input, meta, placeholder, ...props } = this.props;

    return (
      <InputBox>
        <input
          type={props.type ? props.type : 'text'}
          {...input}
          {...props}
          placeholder={placeholder}
        />
        <span className="animation" />

        {meta.touched && meta.error && (
          <ErrorMessage show={meta.touched && meta.error}>
            <FaExclamation size="1em" />
            <div className="errorText">
              <div className="innerErrorText">{meta.error}</div>
            </div>
          </ErrorMessage>
        )}
      </InputBox>
    );
  }
}

export default Input;
